import type { FishGroupOperationSummary, FishGroupTransferEvent } from './historyTypes';

/** Discards and reverts are final; everything else can be annulled. */
export function isRevertibleOperation(operation: FishGroupOperationSummary): boolean {
    return (
        operation.operationType !== 'discard' &&
        operation.operationType !== 'revert' &&
        operation.revertedByOperationId === null
    );
}

/**
 * The operation the group's history ends on, when it can still be reverted: what
 * "revert the last operation" offers from the group itself. `events` come newest
 * first, as the events endpoint returns them. Manual events and corrections carry
 * no operation and are skipped. When the latest operation is itself a revert (or a
 * discard) there is nothing to offer: reverts unwind one at a time, newest first,
 * and the backend refuses anything else.
 */
export function findLatestRevertibleOperation(
    events: readonly FishGroupTransferEvent[]
): FishGroupOperationSummary | null {
    const latest = events.find((event) => event.operation !== null)?.operation ?? null;
    return latest !== null && isRevertibleOperation(latest) ? latest : null;
}
